import axios from "axios";

// Declare global constants injected by Vite define
declare const API_BASE_URL: string;

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export default apiClient;
